import { AxiosResponse } from "axios";
import { all, call, put, takeEvery } from "redux-saga/effects";

import * as actions from "./actions";
import * as types from "./types";
import * as services from "./service";
import * as alert from "../alert/actions";
import * as actionTypes from "./actionTypes";

function* postEventTriggersSaga(action: types.PostEventTriggersRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IEventTriggersSuccess | types.IApiError> = yield call(services.postEventTriggers, action.payload);
        if (response.status === 201) {
            let dataPayload = response.data as types.IEventTriggersSuccess;
            yield put(
                actions.postEventTriggersSuccess({
                    trigger: dataPayload
                })
            );
            yield put(alert.enqueueSnackbar({ message: `Event based trigger successful. Timestamp: ${timestamp}`, options: { variant: "success" } }));

        }

        //Show IApiError
        if (response.status !== 201) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}`;
            yield put(
                alert.enqueueSnackbar({
                    message: errmsg,
                    options: { variant: "error" },
                })
            );
            yield put(
                actions.posteventTriggersFailure({
                    error: apiError,
                })
            );
        }
    } catch (e: any) {
        yield put(
            actions.posteventTriggersFailure({
                error: e.message,
            })
        );
    }
}

//put Metadata Extractor
function* putEventsSaga({ eventId, payload }: types.PutEventsRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IPutEventsSuccess | types.IApiError> = yield call(services.putEventsTrigger, eventId, payload);

        if (response.status === 204) {
            let dataPayload = response.data as types.IPutEventsSuccess;
            yield put(
                actions.putEventsSuccess({
                    eventsStatus: dataPayload,
                })
            );
            let successMsg = `The event trigger was successfully edited. ID: ${eventId}, Timestamp: ${timestamp}.`;
            yield put(alert.enqueueSnackbar({ message: successMsg, options: { variant: "success" } }));
        }

        if (response.status !== 204) {
            let apiError = response.data as types.IApiError;
            let errMsg = `StatusCode: ${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestaamp: ${timestamp}.`;
            yield put(alert.enqueueSnackbar({ message: errMsg, options: { variant: "error" } }));

        }
    } catch (e: any) {
        yield put(
            actions.putEventsFailure({
                error: e,
            })
        );
    }
}

function* deleteEventTriggerSaga(action: types.DeleteEventsRequest) {
    const timestamp = new Date().toLocaleString();

    try {
        const response: AxiosResponse<types.IDeleteEventsSuccess | types.IApiError> = yield call(services.deleteEventsTrigger, action.params);
        if (response.status === 204) {
            yield put(
                actions.deleteEventsSuccess({
                    success: true
                })
            );
            yield put(alert.enqueueSnackbar({ message: `The extractor trigger was successfully deleted, Timestamp:${timestamp}.`, options: { variant: "success" } }));

        }

        //Show IApiError
        if (response.status !== 204) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: errmsg, options: { variant: "error" } }));
        }

    } catch (e: any) {
        yield put(
            actions.deleteEventsFailure({
                error: e,
            })
        );
    }
}
/*
  Watcher saga - intercept the action fired from view
  Starts worker saga on latest dispatched `FETCH_ACCESSCONTROL_REQUEST` action.
  Allows concurrent increments.
*/
function* eventTriggerSaga() {
    yield takeEvery(actionTypes.POST_EVENTTRIGGERS_REQUEST, postEventTriggersSaga);
}

function* deleteEventsSaga() {
    yield takeEvery(actionTypes.DELETE_EVENTTRIGGERS_REQUEST, deleteEventTriggerSaga);
}

function* editEventPutSaga() {
    yield takeEvery(
        actionTypes.PUT_EVENTTRIGGERS_REQUEST,
        putEventsSaga
    );
}

function* triggerSaga() {
    yield all([
        eventTriggerSaga(),
        deleteEventsSaga(),
        editEventPutSaga(),])
}

export default triggerSaga;